import { notification } from 'antd'

export const apiDownloadRequest = (url, fileName, contentType) => {
  const payload = {
    method: 'GET',
    credentials: 'include',
  }

  fetch(url, payload)
    .then(response => response.blob())
    .then(blob => {
      const blobType = blob.type || contentType || 'application/octet-stream'
      const blobUrl = window.URL.createObjectURL(new Blob([blob], { type: blobType }))
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = fileName || 'download'
      document.body.appendChild(link)

      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(blobUrl)

      if (blob) {
        notification.success({
          message: 'Success!',
          description: 'File downloaded successfully',
        })
      }
    })
    .catch(error => {
      console.error('Error fetching the file:', error)
      notification.error({
        message: 'Error!',
        description: error?.message || 'File download failed',
      })
    })
}

const parseResponseMessage = message => {
  if (!message) {
    return 'System error!'
  }
  if (Array.isArray(message)) {
    return message.join(', ')
  }

  return message
}

export async function apiRequest(endpoint, method = 'GET', params = null, jsonRequest = false, isFormData = false) {
  let result
  const payload = {
    method: method,
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }

  if (isFormData) {
    delete payload.headers['Content-Type']
  }
  if (['POST', 'PATCH'].includes(method) || jsonRequest === true) {
    if (params instanceof FormData) {
      payload.body = params
    } else {
      payload.body = JSON.stringify(params)
    }
  }

  try {
    const response = await fetch(`${endpoint}`, payload)
    const body = await response.text()
    result = (body && body !== 'null') ? JSON.parse(body) : {}

    if (response.status >= 500 || response.status === 404) {
      notification.error({
        message: 'System error!',
        description: parseResponseMessage(result.message),
      })
      return { ok: false }
    }

    if (response.status === 401) {
      // Only redirect if not already on the login page
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
      return { ok: false, status: 401 }
    }

    if (response.status >= 300) {
      notification.error({
        message: 'System error!',
        description: parseResponseMessage(result.message),
      })
      return { ok: false }
    }

    delete result.statusCode
    result.ok = true

    return result
  } catch (error) {
    notification.error({
      message: 'Error!',
      description: error?.message || 'System error!',
    })
    return { ok: false }
  }
}
